import React from "react";
import FormGetData from "./components/FormGetEvents";
import Login from "./components/Login";
import Heading from "./components/Heading";
import CardSummary from "./Utilities/CardSummary";
import EventCardContainer from "./components/EventCardContainer";
import "./index.css";

import { gapi, CLIENT_ID, DISCOVERY_DOCS, SCOPES } from "./config/googleDocs";

export default function App() {
  // Filtered events from CardSummary.js
  const [filteredEvents, setFilteredEvents] = React.useState([]);

  // Define events
  const [events, setEvents] = React.useState([]);

  // Get user name
  const [googleUser, setGoogleUser] = React.useState("");

  // Check & Change Google oAuth2 Sign In Status
  const [SignedIn, setSignedIn] = React.useState(false);

  // Select A Calendar to get data from
  const [calendarList, setCalendarList] = React.useState([]);
  const [calendarId, setCalendarId] = React.useState("primary");

  // Form Implementaiatin(what data range to get from the selected calendar)
  const [formData, setFormData] = React.useState({
    startDate: "",
    endDate: "",
    contains: "",
  });

  // Next Button Enable Check
  const [renderSearchCriteria, setRenderSearchCriteria] = React.useState(false);
  const isSubmitButtonEnabled =
    formData.startDate.length > 0 &&
    formData.endDate.length > 0 &&
    formData.contains.length > 0;

  // Update user name
  function setGoogleUserName(userName) {
    setGoogleUser(userName);
  }

  // Select user's calendar for event API call
  function handleCalendarChange(event) {
    setCalendarId(event.target.value);
  }

  // Control Form Data(Get Events)
  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [name]: value,
      };
    });
  }

  // Manage Form Sumbition(Get Events)
  function handleSubmit(event) {
    if (!isSubmitButtonEnabled) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    listCalendarEvents();
    setRenderSearchCriteria(true);
  }

  // Monitor Sign In Status & Set SignedIn State
  function updateSigninStatus(isSignedIn) {
    if (isSignedIn) {
      setSignedIn(isSignedIn);
    } else {
      setSignedIn(isSignedIn);
    }
  }

  // Use Google oAuth to Sign In User
  function login() {
    gapi.load("client:auth2", () => {
      gapi.client.init({
        apiKey: process.env.REACT_APP_API_KEY,
        clientId: CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
      });

      gapi.client.load("calendar", "v3");

      gapi.auth2
        .getAuthInstance()
        .signIn()
        .then((response) => {
          gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
          updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
          getUserCalendars();
          setGoogleUserName(response.vu.jf);
        });
    });
  }

  // Logout User from Google
  function logout() {
    gapi.auth2.getAuthInstance().signOut();
  }

  // Make Google Calendar API Call (Request Calendars)
  function getUserCalendars() {
    gapi.client.calendar.calendarList
      .list({
        minAccessRole: "owner",
        showDeleted: false,
        showHidden: false,
      })
      // List Calendars That User Has Access To
      .then((response) => {
        let calendarOptions = [];
        const calendars = response.result.items;
        calendars.forEach((cal) => {
          calendarOptions.push({
            label: cal.summary,
            id: cal.id,
          });
        });
        setCalendarList(calendarOptions);
      });
  }

  // Make Google Calendar API Call (Events)
  function listCalendarEvents() {
    // List Events User has requested
    gapi.client.calendar.events
      .list({
        calendarId: calendarId,
        timeMin: new Date(formData.startDate).toISOString(),
        timeMax: new Date(formData.endDate).toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: 10000,
        orderBy: "startTime",
        q: formData.contains,
      })
      .then((response) => {
        const eventsArr = response.result.items;
        setEvents(eventsArr);
      });
  }

  return (
    <div id="app-container" className="m-auto w-full max-w-md flex-col">
      {!SignedIn ? <Login login={login} /> : ""}

      {SignedIn ? (
        <div className="space-y-6">
          <Heading logout={logout} googleUser={googleUser} />

          {!renderSearchCriteria ? (
            <FormGetData
              formData="formData"
              listCalendarEvents={listCalendarEvents}
              logout={logout}
              calendarList={calendarList}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              handleCalendarChange={handleCalendarChange}
              isSubmitButtonEnabled={isSubmitButtonEnabled}
            />
          ) : (
            <CardSummary
              setRenderSearchCriteria={setRenderSearchCriteria}
              events={events}
              setFilteredEvents={setFilteredEvents}
            />
          )}
          {filteredEvents <= 0 ? (
            ""
          ) : (
            <EventCardContainer
              filteredEvents={filteredEvents}
              eventTitle={formData.contains}
            />
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
